module.exports = __webpack_public_path__ + "img/11.8dab9941.jpg";